// Note: mobx doesn't allow super classes so this is more of a template
import { action, makeObservable, observable } from "mobx";
import { Messages } from "core/constants";

export class BaseStore {
    isLoading = false;
    hasError = false;
    errorMessage = "";
    isPopulated = false;

    constructor() {
        makeObservable(this, {
            isLoading: observable,
            hasError: observable,
            errorMessage: observable,
            isPopulated: observable,
            reset: action,
            updateHasError: action,
            updateIsLoading: action
        });
    }

    updateIsLoading(value: boolean) {
        this.isLoading = value;
    }

    updateHasError(value: boolean, message = Messages.apiError) {
        this.hasError = value;
        this.errorMessage = message;
    }

    reset() {
        this.isLoading = false;
        this.hasError = false;
        this.errorMessage = "";
        this.isPopulated = false;
    }
}
